import React from "react";
import { useI18next, Link, useTranslation } from 'gatsby-plugin-react-i18next';
import './pages-navigator.css'

const PagesNavigator = ({ numPages, currentPage, currentPath }) => {
    const { language } = useI18next();
    const { t } = useTranslation();

    const pagesBefore = Array.from({ length: Math.min(currentPage - 1, 3) }, (_, i) => currentPage - i - 1)
        .filter((page) => page > 0)
        .reverse();

    const pagesAfter = Array.from({ length: Math.min(numPages - currentPage, 3) }, (_, i) => currentPage + i + 1)
        .filter((page) => page <= numPages);

    return (
        <>
        {numPages > 1 && (
            <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <Link to={`${currentPath}${(currentPage - 1) > 1 ? `${(currentPage - 1)}/` : ''}`} className="page-link custom-navigation-link" tabIndex="-1">
                    {t('common.previous', { lng: language })}
                </Link>
            </li>

            {pagesBefore.map((page) => (
                <li key={page} className="page-item">
                    <Link to={`${currentPath}${page > 1 ? `${page}/` : ''}`} className="page-link custom-navigation-link">
                        {page}
                    </Link>
                </li>
            ))}

            <li className="page-item active">
                <span className="page-link custom-navigation-page-active">{currentPage}</span>
            </li>

            {pagesAfter.map((page) => (
                <li key={page} className="page-item">
                    <Link to={`${currentPath}${page > 0 ? `${page}/` : ''}`} className="page-link custom-navigation-link">
                        {page}
                    </Link>
                </li>
            ))}

            <li className={`page-item ${currentPage >= numPages ? "disabled" : ""}`}>
                <Link to={`${currentPath}${currentPage + 1}`} className="page-link custom-navigation-link">
                    {t('common.next', { lng: language })}
                </Link>
            </li>
        </ul>
        )}
        </>
    );
};

export default PagesNavigator;